/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import styles from '../../../assets/css/layoutMain/providers/providers.module.css';
import images from '../../../assets/images';
import useEditIntro from '../../profile/useEditIntro';
import useEditAbout from '../../profile/useEditAbout';
import useEditIntroAbout from '../../profile/useEditIntroAbout';
import { useGetUserProfile } from '../../../hooks/api/useUserProfile';

const SectionProfile = () => {
    const { data } = useGetUserProfile();
    const [openEditIntro, ModalEditIntroForm] = useEditIntro();
    const [openEditAbout, ModalEditAboutForm] = useEditAbout();
    const [openIntroAbout, ModalIntroAbout] = useEditIntroAbout();

    useEffect(() => {
        if (data?.completeProfile === false) {
            openIntroAbout();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <div className={styles.cardProviders}>
            <section className={styles.provider}>
                <div className={styles.provider__title}>
                    <img src={images.campLogo} alt="icon" />
                    <h4 src={images.h4}>Profile</h4>
                </div>
                <div className={styles.provider__content_profile}>
                    <a onClick={openEditIntro} href="#!">
                        <img src={images.pencil} alt="icon" />
                        Edit Intro
                    </a>

                    <a onClick={openEditAbout} href="#!">
                        <img src={images.pencil} alt="icon" />
                        Edit About
                    </a>
                </div>
            </section>
            {ModalEditIntroForm}
            {ModalEditAboutForm}
            {ModalIntroAbout}
        </div>
    );
};

export default SectionProfile;
